<template>
  <teleport v-if="position === 'fixed'" to="body">
    <transition name="fade-in">
      <div v-if="isLoading" class="atom-loader-logo">
        <ClientOnly>
          <div class="atom-loader-logo__inner">
            <IonIcon
              icon-name="promologic-logo"
              :icon-color="iconColor"
              class="atom-loader-logo__icon"
              icon-size="40px"
            />

            <div class="atom-loader-logo__text">
              {{ text }}
            </div>

            <div v-if="subtitle" class="atom-loader-logo__subtitle">
              {{ subtitle }}
            </div>
          </div>
        </ClientOnly>
      </div>
    </transition>
  </teleport>

  <transition v-else name="fade-in">
    <div v-if="isLoading" class="atom-loader-logo is-absolute">
      <div class="atom-loader-logo__inner">
        <IonIcon
          icon-name="promologic-logo"
          :icon-color="iconColor"
          class="atom-loader-logo__icon"
          icon-size="40px"
        />

        <div class="atom-loader-logo__text">
          {{ text }}
        </div>

        <div v-if="subtitle" class="atom-loader-logo__subtitle">
          {{ subtitle }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
defineProps({
    text: {
        type: String,
        default: 'Viel Glück!',
    },

    subtitle: {
        type: String,
        default: '',
    },

    iconColor: {
        type: String,
        default: 'var(--c-primary)',
    },

    isLoading: {
        type: Boolean,
        default: true,
    },

    position: {
        type: String,
        default: 'fixed',
    },
});
</script>

<style lang="scss" scoped>
/*
  Rotate forward and backwards infinitely
  from -10 degrees to 10 degrees and back
*/
@keyframes rotate {
    0% {
        transform: rotate(-15deg);
    }
    50% {
        transform: rotate(15deg);
    }
    100% {
        transform: rotate(-15deg);
    }
}

.atom-loader-logo {
    @include z-index('loaderOverlay');

    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(5px);
    background-color: var(--c-white--transparent);

    &.is-absolute {
        position: absolute;
    }
}

.atom-loader-logo__inner {
    display: flex;
    width: 100%;
    max-width: 190px;
    height: 100%;
    max-height: 190px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border-radius: var(--b-radius--big);
    background: var(--c-white);
    box-shadow: var(--box-shadow--regular);
    color: var(--c-primary);
    font-family: var(--f-family--primary);
    font-size: var(--f-size--button);
    font-weight: var(--f-weight--900);
    line-height: var(--l-height--button);
    row-gap: 10px;

    .is-absolute & {
        background: none;
        box-shadow: none;
    }
}
.atom-loader-logo__icon {
    margin-bottom: 10px;
    animation: rotate 1.2s infinite;
}

.atom-loader-logo__text {
    text-align: center;
}

.atom-loader-logo__subtitle {
    font-size: var(--f-size--description);
    font-weight: var(--f-weight--500);
    line-height: var(--l-height--description);
    text-align: center;
}
</style>
